// src/Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div style={styles.container}>
        <p style={styles.disclaimer}>
          By using this website you are governed by our Terms and policies.
        </p>
        <div style={styles.rightContent}>
          <p style={styles.copyright}>
            © 2024-26 &nbsp;
            <a
              href="https://www.omnevu.com"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.link}
            >
              Omnevu.com
            </a>
          </p>
          <div style={styles.linksContainer}>
            <a
              href="/terms-and-conditions"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.link}
            >
              Terms & Conditions
            </a>
            <span style={styles.separator}> | </span>
            <a
              href="/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.link}
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '10px',
    flexWrap: 'wrap',
    padding: '14px 20px',
    background: '#fefce8',
    borderTop: '1px solid #f0d060',
  },
  disclaimer: {
    margin: 0,
    fontSize: '13px',
    color: '#6a6000',
    whiteSpace: 'nowrap',
    fontFamily: "'Epilogue', sans-serif",
  },
  rightContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap',
  },
  copyright: {
    margin: 0,
    fontSize: '13px',
    color: '#6a6000',
    whiteSpace: 'nowrap',
    fontFamily: "'Epilogue', sans-serif",
  },
  linksContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0',
  },
  separator: {
    color: '#6a6000',
    margin: '0 6px',
  },
  link: {
    color: '#f59e0b',
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
    fontSize: '13px',
    fontFamily: "'Epilogue', sans-serif",
    fontWeight: 600,
  },
};

export default Footer;
